import React from 'react';
import {useNavigate} from 'react-router-dom';

export const Cuidador = (props) => {
	const {
		fotoUsuario,
		nombreUsuario,
		idUsuario,
		direccionUsuario,
		telefonoUsuario,
		correoUsuario,
		telefonoUsuario2,
		abrirPerfil,
	} = props;

	return (
		<>
			<div
				className='Usuario'
				onClick={() => abrirPerfil(idUsuario, nombreUsuario)}
			>
				<div className='fotoUsuario centrador'>
					<div className='fotoNombreUsuario'>
						<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
					</div>
					<div className='nombreIdUsuario '>
						<div className='nombreUsuario'>{nombreUsuario}</div>
						{/*<div className='idUsuario'><b>ID : </b>{idUsuario}</div>*/}
					</div>
				</div>
				<div className='datosUsuario'>
					<div className='direccionUsuario'>
						<b>Dirección : </b>
						{direccionUsuario}
					</div>
					<div className='telefonoUsuario'>
						<b>Teléfono : </b>
						{telefonoUsuario}
					</div>
				</div>
				<div className='datosUsuario'>
					<div className='correoUsuario'>
						<b>Correo : </b>
						{correoUsuario}
					</div>
					<div className='telefonoUsuario'>
						<b>Teléfono 2 : </b>
						{telefonoUsuario2}
					</div>
				</div>
			</div>
		</>
	);
};
